import { notification } from "antd"
import * as plamoApis from "../../../api/plamo-api";

export function showSuccessMessage() {
  notification.success({
    message: 'Änderung erfolgreich gespeichert',
    description:
      'Die Änderungen wurden im System übernommen',
    })
}

export function showErrorMessage() {
  notification.error({
    message: 'Speichern fehlgeschlagen',
    description:
      'Die Änderungen wurden NICHT übernommen. Bitte versuchen Sie es später noch einmal.',
    })
}

function withSaveNotification(func) {
  return async (...args) => {
    console.log("Executing update with args", args);
    try {
      const result = await func(...args)
      console.log("Result", result);
      if(result.error) {
        showErrorMessage();
      } else {
        showSuccessMessage();
      }
      return result;
    } catch(e) {
      showErrorMessage();
    }
  }
}

const createHook = hook => {
  return () : any => {
    const [save, ...rest] = hook();
    return [withSaveNotification(save), ...rest];
  }
}

const PlamoApiWithSaveNotifications = Object.entries(plamoApis)
    .filter(([key, _]: [string, any]) => key.startsWith('use') && key.endsWith('Mutation'))
    .map(([key, func]: [string, any]) => ({ key: key.replace(/Mutation$/, "WithSaveNotificationMutation"), value: createHook(func) }))
    .reduce((p: any, { key, value }) => ({...p, [key]: value }), {});

//export const useCreateCustomerWithSaveNotificationMutation = createHook(plamoApis.useCreateCustomerMutation);
//export const useUpdateCustomerWithSaveNotificationMutation = createHook(plamoApis.useUpdateCustomerMutation);
//export const useDeleteCustomerWithSaveNotificationMutation = createHook(plamoApis.useDeleteCustomerMutation);

export default PlamoApiWithSaveNotifications

